<div class="flex items-center justify-center" [className]="customClasses">
    <ng-container *ngIf="whiteLogo; else defaultLogo">
        <img class="w-auto h-full" src="assets/images/logo/lensbook-white.png" />
    </ng-container>
    <ng-template #defaultLogo>
        <img class="w-auto h-full" src="assets/images/logo/lensbook.png" />
    </ng-template>
</div>
